import { makeObservable, observable, action } from 'mobx';

var SelectedResultInfoStore = /** @class */ (function () {
    function SelectedResultInfoStore() {
        this.selectedResultInfo = {
            resultKey: '',
            resultSalt: '',
            resultHash: '',
        };
        makeObservable(this, {
            selectedResultInfo: observable,
            setSelectedResultInfo: action.bound,
        });
    }
    SelectedResultInfoStore.prototype.setSelectedResultInfo = function (selectedResult) {
        this.selectedResultInfo = selectedResult;
    };
    return SelectedResultInfoStore;
}());
var selectedResultInfoStore = new SelectedResultInfoStore();

export { SelectedResultInfoStore, selectedResultInfoStore };
